import { render, staticRenderFns } from "./CoinLogBody.vue?vue&type=template&id=5bdde56a&"
import script from "./CoinLogBody.vue?vue&type=script&lang=ts&"
export * from "./CoinLogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports